import type { GifData } from './types';

export function makeDefault(): GifData {
  return {
    url: '',
    stillUrl: '',
    width: 480,
    height: 270,
    source: 'klipy',
  };
}
